import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/waiting-list-users',
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '/waiting-list-users',
                    name: 'waiting list users',
                    component: () => import("./views/waitingListUsers.vue")
                }
            ]
        }
    ];
};